import { render, staticRenderFns } from "./center-anchor.vue?vue&type=template&id=17f7ec8a&scoped=true"
import script from "./center-anchor.vue?vue&type=script&lang=js"
export * from "./center-anchor.vue?vue&type=script&lang=js"
import style0 from "./center-anchor.vue?vue&type=style&index=0&id=17f7ec8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f7ec8a",
  null
  
)

export default component.exports